import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/pearland")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Pearland, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Pearland & Brazoria County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Pearland, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Pearland and Brazoria County.",
      keywords: "awnings Pearland, awning company Pearland, custom awnings Pearland, sail shades Pearland, patio covers Pearland, pergola covers Pearland, metal awnings Pearland, canvas awnings Pearland, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Pearland", "Brazoria County"),
  }),
  component: () => <CityHomePage city="Pearland" region="Brazoria County" />,
});
